/*
 * BAYA wishlist (favorites)
 * Pure client-side wishlist stored in localStorage — no app, no login required.
 * - Toggles hearts on product cards ([data-wishlist-toggle])
 * - Keeps the header counter in sync ([data-wishlist-count])
 * - Renders the favorites page grid ([data-wishlist-grid]) by fetching each
 *   product's card via the Section Rendering API (?section_id=wishlist-product-item),
 *   the same technique the theme's "recently viewed" uses.
 */
(function () {
  var STORAGE_KEY = 'baya:wishlist:v1';
  var CARD_SECTION = 'wishlist-product-item';

  function readList() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function toggleHandle(handle) {
    var list = readList();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    writeList(list);
    return list;
  }

  function updateCount() {
    var n = readList().length;
    var nodes = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      nodes[i].hidden = n === 0;
    }
  }

  function syncButtons() {
    var list = readList();
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var handle = buttons[i].getAttribute('data-wishlist-handle');
      var active = list.indexOf(handle) !== -1;
      buttons[i].classList.toggle('is-active', active);
      buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-wishlist-empty]');
    var loading = document.querySelector('[data-wishlist-loading]');
    var list = readList();

    grid.innerHTML = '';

    if (list.length === 0) {
      if (empty) empty.hidden = false;
      if (loading) loading.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;

    var pending = list.length;

    list.forEach(function (handle) {
      // Placeholder slot keeps the saved order stable regardless of fetch timing
      var slot = document.createElement('div');
      slot.className = 'wishlist-grid__item';
      grid.appendChild(slot);

      fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (html && html.trim()) {
            slot.innerHTML = html;
          } else {
            // Product no longer exists / unavailable — drop it from the list and the DOM
            var current = readList();
            var idx = current.indexOf(handle);
            if (idx !== -1) { current.splice(idx, 1); writeList(current); }
            slot.parentNode && slot.parentNode.removeChild(slot);
          }
        })
        .catch(function () {
          slot.parentNode && slot.parentNode.removeChild(slot);
        })
        .then(function () {
          pending--;
          if (pending === 0) {
            if (loading) loading.hidden = true;
            updateCount();
            syncButtons();
            if (readList().length === 0 && empty) empty.hidden = false;
          }
        });
    });
  }

  function onClick(e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    toggleHandle(handle);
    syncButtons();
    updateCount();
    if (document.querySelector('[data-wishlist-grid]')) renderGrid();
  }

  function init() {
    updateCount();
    syncButtons();
    renderGrid();
  }

  document.addEventListener('click', onClick);

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Re-sync when sections re-render (theme editor, filters, pagination, quick view)
  document.addEventListener('shopify:section:load', init);

  window.BayaWishlist = { read: readList, toggle: toggleHandle, refresh: init };
})();
